var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 1.49996C0.666748 1.03972 1.03984 0.666626 1.50008 0.666626H8.99662C9.45686 0.666626 9.82996 1.03972 9.82996 1.49996C9.82996 1.9602 9.45686 2.33329 8.99662 2.33329H2.33341V15.6666H9.00008C9.46032 15.6666 9.83342 16.0397 9.83342 16.5C9.83342 16.9602 9.46032 17.3333 9.00008 17.3333H1.50008C1.03984 17.3333 0.666748 16.9602 0.666748 16.5V1.49996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1608 4.6607C12.4863 4.33527 13.0139 4.33527 13.3393 4.6607L17.0438 8.36518C17.2211 8.518 17.3334 8.74424 17.3334 8.9967L17.3334 8.99823C17.3339 9.21208 17.2525 9.42606 17.0893 9.58922L13.3393 13.3392C13.0139 13.6647 12.4863 13.6647 12.1608 13.3392C11.8354 13.0138 11.8354 12.4861 12.1608 12.1607L14.4915 9.83004H5.66675C5.20651 9.83004 4.83342 9.45694 4.83342 8.9967C4.83342 8.53647 5.20651 8.16337 5.66675 8.16337H14.485L12.1608 5.83922C11.8354 5.51378 11.8354 4.98614 12.1608 4.6607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOn);
export default __webpack_public_path__ + "static/media/logout-on.9f181227e96add01f2a7fff0f85579b0.svg";
export { ForwardRef as ReactComponent };